function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "finals"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "5.04 108.79 5.04 113.52 78.02 113.52 78.02 108.79 83.3 108.79 83.3 30.22 0 30.22 0 108.79 5.04 108.79"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 20.41,
  y: 48.73,
  width: 42.17,
  height: 28.94,
  transform: "translate(82.98 126.39) rotate(180)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 12.1,
  y: 47.07,
  width: 42.17,
  height: 28.94,
  transform: "translate(40.29 131.1) rotate(-157.5)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 5.06,
  y: 42.37,
  width: 42.17,
  height: 28.94,
  transform: "translate(4.44 115.52) rotate(-135)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 0.35,
  y: 35.33,
  width: 42.17,
  height: 28.94,
  transform: "translate(-16.37 88.66) rotate(-112.5)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: -1.3,
  y: 27.02,
  width: 42.17,
  height: 28.94,
  transform: "translate(-21.71 61.28) rotate(-90)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 0.35,
  y: 18.71,
  width: 42.17,
  height: 28.94,
  transform: "translate(-17.42 40.29) rotate(-67.5)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 5.06,
  y: 11.67,
  width: 42.17,
  height: 28.94,
  transform: "translate(-10.83 26.14) rotate(-45)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 12.1,
  y: 6.97,
  width: 42.17,
  height: 28.94,
  transform: "translate(-5.68 14.33) rotate(-22.5)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 20.41,
  y: 5.32,
  width: 42.17,
  height: 28.94
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 28.71,
  y: 6.97,
  width: 42.17,
  height: 28.94,
  transform: "translate(11.99 -17.42) rotate(22.5)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 35.75,
  y: 11.67,
  width: 42.17,
  height: 28.94,
  transform: "translate(35.13 -32.53) rotate(45)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 40.46,
  y: 18.71,
  width: 42.17,
  height: 28.94,
  transform: "translate(68.65 -36.37) rotate(67.5)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 42.11,
  y: 27.02,
  width: 42.17,
  height: 28.94,
  transform: "translate(104.69 -21.71) rotate(90)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 40.46,
  y: 35.33,
  width: 42.17,
  height: 28.94,
  transform: "translate(131.1 11.99) rotate(112.5)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 35.75,
  y: 42.37,
  width: 42.17,
  height: 28.94,
  transform: "translate(137.22 56.84) rotate(135)"
})));

var SvgTelecomsFibre = function SvgTelecomsFibre(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 83.3 113.52",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelecomsFibre, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telecoms-fibre.5a37445e.svg";
export { ForwardRef as ReactComponent };